module.exports = __webpack_public_path__ + "static/media/sd.c466d90e.svg";